/* eslint-disable @typescript-eslint/no-empty-interface */
import React, { Component } from 'react';
import { confirmWrapper } from 'src/components/Dialog';
import withRouter from '../../hooks/withRouter';

import {
  CareersProps,
  CareersState,
  CareersViewRendererProps,
  OpenJob,
} from './types';
import API from '../../network';

import ViewRenderer from './views';

type Props = CareersProps;

class Careers extends Component<Props, CareersState> {
  constructor(props: Props) {
    super(props);

    const { router } = this.props;

    const orgId = router?.params?.orgId;

    this.state = {
      orgId: Number(orgId) ?? 0,
      loading: false,
      careers: [],
    };
  }

  componentDidMount() {
    this.fetchCareers();
  }

  fetchCareers = async () => {
    this.setState({
      loading: true,
    });
    const { orgId } = this.state;

    try {
      const response: OpenJob[] = await API.getInstance().getCareersByOrgId(orgId);
      this.setState({
        careers: response,
      });
    } catch (e) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  getProps = (): CareersViewRendererProps => {
    const {
      orgId, loading, careers,
    } = this.state;

    return {
      loading,
      careers,
      orgId,
    };
  };

  render() {
    const viewProps: CareersViewRendererProps = this.getProps();

    return (
      <ViewRenderer {...viewProps} />
    );
  }
}

export default withRouter(Careers);
